const l = `<svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 14 14">
    <path fill="currentColor" fill-rule="evenodd"
        d="M3 1.5C3 0.671573 3.67157 0 4.5 0H12.5C13.3284 0 14 0.671573 14 1.5V3.5C14 4.32843 13.3284 5 12.5 5H4.5C3.67157 5 3 4.32843 3 3.5V3.25H2.25C1.83579 3.25 1.5 3.58579 1.5 4V5C1.5 5.69036 2.05964 6.25 2.75 6.25H6C7.51878 6.25 8.75 7.48122 8.75 9V9.02074C9.45943 9.13976 10 9.75675 10 10.5V13.5C10 13.7761 9.77614 14 9.5 14H6.5C6.22386 14 6 13.7761 6 13.5V10.5C6 9.75675 6.54057 9.13976 7.25 9.02074V9C7.25 8.30964 6.69036 7.75 6 7.75H2.75C1.23122 7.75 0 6.51878 0 5V4C0 2.75736 1.00736 1.75 2.25 1.75H3V1.5Z"
        clip-rule="evenodd"></path>
</svg>`;
export {
  l as default
};
